import React, {useCallback, useRef} from 'react'
import {GoogleMap, Marker} from "@react-google-maps/api"
import {makeStyles} from "@material-ui/core/styles";
import mapStyles from "./mapStyles";
import scaleBar3Km from "../images/scaleBar3KmNew.svg"
import scaleBar1km from "../images/scaleBar1KmNew.svg";
import {useTranslation} from "react-i18next";
const useStyles = makeStyles((theme) => ({
    map: {
        position: "relative",
        minWidth: "260px",
        maxWidth: "480px",
        // height: "329px",
        aspectRatio: "1 / 1",
        height: "100%",
        borderRadius: "8px",
    }
}));

const options = {
    styles: mapStyles,
    clickableIcons: false,
    keyboardShortcuts: false,
    disableDefaultUI: true,
    zoomControl: false,
    // disable cursor
    gestureHandling: 'none',
    scrollwheel: false,
}
export default function GoogleMapComponent({markers, zoom, center, url}) {
    const classes = useStyles();
    const markerCenter = []
    const {t, i18n} = useTranslation()
    markerCenter.push(center)
    const mapRef = useRef()
    const onMapLoad = useCallback((map) => {
        mapRef.current = map
    }, [])

    return (<>
            <div className="containerMap">
                <GoogleMap
                    mapContainerClassName={classes.map}
                    zoom={zoom}
                    language={i18n.language}
                    region={i18n.language}
                    center={center}
                    options={options}
                    onLoad={onMapLoad}
                >
                    {markers?.map(marker => <Marker
                        key={marker.lat + marker.lng}
                        position={{
                            lat: marker.lat,
                            lng: marker.lng
                        }}
                        icon={{
                            anchor: new window.google.maps.Point(20, 20),
                            url: url,
                        }}

                    />)}
                    {markerCenter?.map(marker => <Marker
                        key={marker.lat + marker.lng}
                        position={{
                            lat: marker.lat,
                            lng: marker.lng
                        }}
                        icon={{
                            anchor: new window.google.maps.Point(12, 28),
                            url: `/pin-location.svg`,
                        }}

                    />)}
                    {url === `/AlertCircle.svg` && <img src={scaleBar1km} alt="meters" className="imageScaleBars"/>}
                    {url === `/Alert.svg` && <img src={scaleBar3Km} alt="meters" className="imageScaleBars"/>}
                </GoogleMap>
            </div>
        </>
    )
}